import { ReactElement } from 'react'
import { useIntl, defineMessages } from 'react-intl'

import { SelectTags } from 'components/v2/SelectTags'
import { STATES } from 'utils/states'

const messages = defineMessages({
  selectStates: {
    id: 'selectStates.placeholder',
    defaultMessage: 'Select states'
  }
})

interface IState {
  code: string
  name: string
}

export const SelectStates = ({
  values,
  onChange,
  touched,
  errors,
  disabled
}: {
  values: IState[]
  onChange: (values: IState[]) => void
  touched?: boolean
  errors?: string
  disabled?: boolean
}): ReactElement => {
  const intl = useIntl()

  const handleChange = (values: IState[]): void => onChange(values)

  const getOptions = (items: IState[]): IState[] => {
    return items.filter((item): boolean => {
      return !values?.find((value): boolean => value.code === item.code)
    })
  }

  return (
    <SelectTags
      id="selectPassengerTypes"
      placeholder={intl.formatMessage(messages.selectStates)}
      values={values || []}
      items={getOptions(STATES ?? [])}
      getTagLabel={(state: IState): string => state.name}
      onChange={handleChange}
      touched={touched}
      errors={errors}
      disabled={disabled}
    />
  )
}
